import {UIGameManager} from '../UIGameManager'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {MovingSpriteView} from '../../ui_canvas_engine/MovingSpriteView'
import {Sound} from '../../Sound'
import {TranslationObject} from '@colonist/i18n'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {MechanicPirateState} from '@colonist/game-states'
import {TileHex, Point} from '@colonist/game-mechanic-validators'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import SoundType = Sound.SoundType

export class UIGameMapPirateController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly pirateState: MechanicPirateState

    private lastPirateTile: TileHex
    private readonly pirateView: MovingSpriteView

    constructor(uiGameManager: UIGameManager, pirateState: MechanicPirateState) {
        this.uiGameManager = uiGameManager
        this.pirateState = pirateState

        const tileWithPirate = this.uiGameManager.gameState.mapState.tileState.tiles[this.pirateState.locationTileIndex]
        if(tileWithPirate == undefined) return

        this.lastPirateTile = tileWithPirate
        const pirateCoords = this.getPirateCoords(this.lastPirateTile)
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_pirate_ship)
        this.pirateView = new MovingSpriteView(pirateCoords.x, pirateCoords.y, this.uiGameManager.mapController.mapView.pirateRadius, this.uiGameManager.mapController.mapView.pirateRadius, this.uiGameManager.mapController.mapView, texture)
        this.pirateView.zIndex = this.uiGameManager.mapController.mapView.layers.pirate
        this.pirateView.animationController.animationCompleteCallBack = () => {
            this.pirateView.zIndex = this.uiGameManager.mapController.mapView.layers.pirate
            this.uiGameManager.mapController.mapView.sortChildren()
        }
        const pirateTipTitle: TranslationObject = {key: 'strings:game.tips.pirate.title'}
        const pirateTipBody: TranslationObject[] = [{key: 'strings:game.tips.pirate.body.0'}, {key: 'strings:game.tips.pirate.body.1'}]
        this.pirateView.setTip(pirateTipTitle, pirateTipBody)

        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.updatePirate(); break
            default: break
        }
    }

    private updatePirate() {
        const pirateTile = this.uiGameManager.gameState.mapState.tileState.tiles[this.pirateState.locationTileIndex]
        if(pirateTile == undefined) return
        if(this.lastPirateTile.sameTileHex(pirateTile)) return

        this.movePirate(pirateTile)
    }

    private movePirate(tile: TileHex) {
        const pirateCoords = this.getPirateCoords(tile)
        this.pirateView.zIndex = this.uiGameManager.mapController.mapView.layers.pirate
        this.uiGameManager.mapController.mapView.sortChildren()
        if(!this.uiGameManager.gameController.isReplay) this.pirateView.animationController.animationCompleteCallBack = () => Sound.playSound(SoundType.PiratePlace)
        this.pirateView.animationController.animateTo(pirateCoords)
        this.lastPirateTile = tile
    }

    private getPirateCoords(tile: TileHex) {
        const tileCenter = tile.hexFace.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2)

        const leftXPosition = tileCenter.x - this.uiGameManager.mapController.mapView.pirateRadius * 1.2
        const leftYPosition = tileCenter.y - this.uiGameManager.mapController.mapView.pirateRadius * 0.25

        const rightXPosition = tileCenter.x + this.uiGameManager.mapController.mapView.pirateRadius * 0.1
        const rightYPosition = tileCenter.y - this.uiGameManager.mapController.mapView.pirateRadius * 0.3

        const isPortOnBottomEastSideOfTile = this.uiGameManager.gameState.mapState.isPortOnEastSideOfTile(tile)

        const x = isPortOnBottomEastSideOfTile ? leftXPosition : rightXPosition
        const y = isPortOnBottomEastSideOfTile ? leftYPosition : rightYPosition

        return new Point(x, y)
    }
}
